import { render } from "./lock-screen.vue?vue&type=template&id=c1b06db8"
import script from "./lock-screen.vue?vue&type=script&lang=js"
export * from "./lock-screen.vue?vue&type=script&lang=js"

import "./lock-screen.vue?vue&type=style&index=0&id=c1b06db8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__